// extracted by mini-css-extract-plugin
export default {"morphPhraseHidden":"MorphPhrase_morphPhraseHidden__t5nes","morphPhraseAnimated":"MorphPhrase_morphPhraseAnimated__V3hhE"};